import React, { useState } from 'react';
import VideoUploadButton from '../../../components/ui/VideoUploadButton';
import Icon from '../../../components/AppIcon';

const LevelTwoSection = ({ data, onChange, error, songId, talentId }) => {
  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');

  const handleInputChange = (field, value) => {
    onChange({
      ...data,
      [field]: value
    });
  };

  const handleVideoUploadSuccess = (uploadData) => {
    setUploadedVideos(prev => [...prev, uploadData]);
    setUploadSuccess(`Video uploaded successfully: ${uploadData?.fileName}`);
    setUploadError('');
    
    // Clear success message after 3 seconds
    setTimeout(() => {
      setUploadSuccess('');
    }, 3000);
  };

  const handleVideoUploadError = (error) => {
    setUploadError(error);
    setUploadSuccess('');
  };

  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6">
      {/* Section Header with Video Upload */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <h2 className="text-2xl font-heading font-bold text-white">Level 2: Exploring</h2>
        
        <VideoUploadButton
          level="level2"
          subsection={null}
          songId={songId}
          talentId={talentId}
          onUploadSuccess={handleVideoUploadSuccess}
          onUploadError={handleVideoUploadError}
          size="md"
          className="shrink-0"
        />
      </div>

      {/* Upload Messages */}
      {uploadError && (
        <div className="mb-4 bg-red-50 bg-opacity-90 border border-red-200 rounded-xl p-3">
          <div className="flex items-center space-x-2">
            <Icon name="AlertTriangle" size={16} className="text-red-800" />
            <p className="text-red-800 text-sm">{uploadError}</p>
          </div>
        </div>
      )}

      {uploadSuccess && (
        <div className="mb-4 bg-green-50 bg-opacity-90 border border-green-200 rounded-xl p-3">
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircle" size={16} className="text-green-800" />
            <p className="text-green-800 text-sm">{uploadSuccess}</p>
          </div>
        </div>
      )}

      {/* Uploaded Videos List */}
      {uploadedVideos?.length > 0 && (
        <div className="mb-6 bg-blue-50 bg-opacity-90 border border-blue-200 rounded-xl p-4">
          <h3 className="text-blue-800 font-medium mb-2">Uploaded Videos ({uploadedVideos?.length})</h3>
          <div className="space-y-2">
            {uploadedVideos?.map((video, index) => (
              <div key={index} className="flex items-center justify-between text-sm text-blue-700 bg-white bg-opacity-50 rounded-lg p-2">
                <div className="flex items-center space-x-2">
                  <Icon name="Video" size={14} />
                  <span>{video?.fileName}</span>
                </div>
                <span className="text-xs">
                  {(video?.fileSize / (1024 * 1024))?.toFixed(1)} MB
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-blue-200 mb-2">
          Basic Discussion
        </label>
        <textarea
          value={data?.basicDiscussion || ''}
          onChange={(e) => handleInputChange('basicDiscussion', e?.target?.value)}
          placeholder="Discuss the basic elements and themes of this song..."
          rows={8}
          className="w-full px-4 py-3 bg-white bg-opacity-10 border border-white border-opacity-30 rounded-xl text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent resize-none"
        />
      </div>

      {error && (
        <div className="mt-4 bg-red-50 bg-opacity-90 border border-red-200 rounded-xl p-3">
          <div className="flex items-center space-x-2">
            <Icon name="AlertTriangle" size={16} className="text-red-800" />
            <p className="text-red-800 text-sm">{error}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LevelTwoSection;